<template>
    <a-spin :spinning="loading">
        <div class="CenteredContent">
            <h3 class="title">One final step: create your avatar</h3>
            <a-avatar v-if="url" :src="url" :size="120" />
            <a-avatar v-else icon="user" :size="120" />
            <a-upload accept="image/png, image/jpeg" :showUploadList="false" name="file" :multiple="false" @change="handleChange">
                <a-button> <a-icon type="upload" /> Click to Upload </a-button>
            </a-upload>
            <a-button class="btn" :disabled="!url" size="large" type="primary" html-type="submit" @click="handleNext">Done</a-button>
        </div>
    </a-spin>
</template>
<script>
import { uploadUrl } from '../../api'
export default {
    props: ['handleSign'],
    data() {
        return {
            url: undefined,
            loading: false,
        }
    },
    methods: {
        async handleChange(info) {
            try {
                this.loading = true
                this.url = await uploadUrl(info.file)
                this.loading = false
            } catch (e) {
                this.loading = false
                return this.$notification.error({
                    message: "Error happened",
                    description: e.message,
                });
            }
        },
        handleNext() {
            this.handleSign(this.url)
        }
    }
}
</script>
<style lang="less" scoped>
.CenteredContent {
    padding: 6.25rem 5rem;
    justify-content: flex-start;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;

    .title {
        font-style: normal;
        font-weight: 500;
        font-size: 30px;
        line-height: 40px;
        font-family: auto;
        text-align: center;
    }

    .btn {
        margin-top: 5rem;
    }
}
</style>